// import { shoptourApi } from 'yxt-biz-pc/packages/api';
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

/**
 * @desc    获取区域树
 * @param   {Number | String} areaName: 区域Id || 0 - 根区域
 */
export const getAreaTree = (areaName) => {
  return apiBaseUrl.get('/si/statement/area-tree', { params: { areaName } });
};
